import { CustomerType } from 'Models'
import { TierInfoType } from 'Models/tierInfoType'
import customerService from 'Services/customerService'
import { BreadCrumb, HorizontalLoader, ModalWrapper } from 'Components'
import { useAuth } from 'Components/AuthProvider/AuthProvider'
import { Fragment, Key, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import './UserDetails.scss'
import { TimeConverter } from 'Helpers/TimeConverter'
import { CurrencyFormatter } from 'Helpers'
import Swal from 'sweetalert2'
import CashBackTierModal from './CashBackTierModal'
import TestTierUpdateModal from './TestTierUpdateModal'
import SetBoostCycleModal from './SetBoostCycleModal'
import TransferToLoan from './TransferToLoan'
import { useForm } from 'react-hook-form'
import { walletService } from 'Services/walletService'
import loanService from 'Services/loanServices'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import { formatString } from 'Helpers/formatString'

const UserDetails = () => {
  const { customerAccountId } = useParams<{ customerAccountId: string }>()

  const [userData, setUserData] = useState<CustomerType>()

  const [request, setRequest] = useState(false)
  const [loading, setLoading] = useState(false)
  const { user } = useAuth()

  const getUser = async () => {
    setRequest(true)
    await customerService.getDetails(customerAccountId).then(
      (response) => {
        setUserData(response.data.data.dataset[0])
        // console.log('getUser', response.data.data.dataset[0])
        setRequest(false)

        getCashbackProgress(response.data.data.dataset[0].msisdn)
      },
      (error: { response: { data: { error: string } } }) => {
        setRequest(false)
        console.log('orderService error', error.response)
      },
    )
  }

  const [showCashbackTierError, setShowCashbackTierError] = useState<string>()
  const [productType, setProductType] = useState<string>('AGO')
  const [productTypeRequest, setProductTypeRequest] = useState<boolean>(false)

  const [tierInfo, setTierInfo] = useState<TierInfoType>()

  const getCashbackProgress = async (msisdn: string) => {
    setProductTypeRequest(true)
    setShowCashbackTierError(undefined)
    const msis = encodeURIComponent(msisdn)
    // console.log('getCashbackProgress msisdn', msisdn)
    // console.log('getCashbackProgress msisdn 2', msis)
    await customerService.getCashbackProgress(msis, productType).then(
      (response) => {
        console.log('cashback', response.data.data)
        setTierInfo(response.data.data)
        setProductTypeRequest(false)
        setShowCashbackTierError(undefined)
      },
      (error: { response: { data: { error: string } } }) => {
        setProductTypeRequest(false)
        setShowCashbackTierError(error.response.data.error)
      },
    )
  }

  useEffect(() => {
    if (userData) getCashbackProgress(userData.msisdn)
  }, [productType])

  useEffect(() => {
    getUser()
  }, [customerAccountId])

  const [customerReferrals, setCustomerReferrals] = useState<CustomerType[]>()

  const getUserReferals = async () => {
    setLoading(true)
    await customerService.allReferrals(1, userData?.id).then(
      (response: {
        data: {
          data: {
            dataset: CustomerType[] | undefined
            pageNumber: number
            pageSize: number
            total: number
          }
        }
      }) => {
        setLoading(false)

        setCustomerReferrals(response?.data.data.dataset)
      },
      (error: { response: { data: { error: string } } }) => {
        setLoading(false)
      },
    )
  }

  useEffect(() => {
    if (userData) {
      getUserReferals()
    }
  }, [userData])

  const [paystactAccount, setPaystackAccount] = useState<{
    bankId: string
    bankName: string
    bankAccountNumber: string
    bankAccountName: string
  }>()
  const [nomaAccount, setNombaAccount] = useState<{
    bankId: string
    bankName: string
    bankAccountNumber: string
    bankAccountName: string
  }>()

  const [nomaAccountError, setNombaAccountError] = useState<string>()
  const [paystackAccountError, setPaystackAccountError] = useState<string>()
  const [accountRequest, setAccountRequest] = useState<boolean>(false)

  const getPaystackAccount = async () => {
    setAccountRequest(true)
    await customerService.getPaystackAccount(userData?.msisdn).then(
      (response) => {
        setAccountRequest(false)
        setPaystackAccount(response.data.data)
        console.log({ khfjghn: response.data.data })
      },
      (error) => {
        setAccountRequest(false)
        setPaystackAccountError(error.response.data.error)
      },
    )
  }

  const getNombaAccount = async () => {
    setAccountRequest(true)
    await customerService.getNombaAccount(userData?.msisdn).then(
      (response) => {
        setAccountRequest(false)
        setNombaAccount(response.data.data)
      },
      (error) => {
        setAccountRequest(false)
        setNombaAccountError(error.response.data.error)
      },
    )
  }

  useEffect(() => {
    if (userData) {
      getPaystackAccount()
      getNombaAccount()
    }
  }, [userData])

  const [showTransferModal, setShowTransferModal] = useState(false)

  const [showUpdateTierModal, setShowUpdateTierModal] = useState(false)
  const [showTestTierModal, setTestTierModal] = useState(false)
  const [showSetBoastCycleModal, setSetBoastCycleModal] = useState(false)
  const [transferToLoanModal, setTransferToLoanModal] = useState(false)

  const [transferLoading, setTransferLoading] = useState(false)

  const toggleTransferModal = () => {
    setShowTransferModal((prevState) => !prevState)
  }

  const [showDebitModal, setShowDebitModal] = useState(false)

  const toggleDebitModal = () => {
    setShowDebitModal((prevState) => !prevState)
  }

  const [reconcileReq, setReconcileReq] = useState(false)

  const reconcileConsentLink = () => {
    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to reconcile this user wallet with tradegride?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, reconcile!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setReconcileReq(true)

        await customerService.reconcileAccount(userData?.msisdn).then(
          () => {
            Swal.fire({
              title: 'Success!',
              text: 'User account has been reconciled successfully.',
              icon: 'success',
            })

            setReconcileReq(false)

            setTimeout(() => {
              getUser()
            }, 3000)
          },
          (error) => {
            setReconcileReq(false)
            Swal.fire({
              title: 'Oops!',
              text: error.response.data.error,
              icon: 'warning',
            })
          },
        )
      }
    })
  }

  const [refreshReq, setRefreshReq] = useState(false)

  const refreshConsentLink = () => {
    Swal.fire({
      title: 'Alert',
      text: 'Are you sure you want to refresh this consent link?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, refresh it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setRefreshReq(true)

        await customerService
          .refreshConsentLink(userData?.msisdn, userData?.loanProvider ?? 'VFD')
          .then(
            () => {
              Swal.fire({
                title: 'Success!',
                text: 'Consent link has been refreshed successfully.',
                icon: 'success',
              })

              setTimeout(() => {
                getUser()
              }, 3000)
            },
            (error) => {
              setRefreshReq(false)
              Swal.fire({
                title: 'Oops!',
                text: error.response.data.error,
                icon: 'warning',
              })
            },
          )
      }
    })
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<{ amount: number }>()

  const submitTransfer = async (data: { amount: number }) => {
    if (userData && userData?.loanProvider) {
      setTransferLoading(true)

      await walletService
        .initiateTransfer(userData?.loanProvider, userData.msisdn, { amount: data.amount })
        .then(
          () => {
            Swal.fire({
              title: 'Success!',
              text: 'Transfer initialized successfully, awaiting approval.',
              icon: 'success',
            })

            setTransferLoading(false)

            toggleTransferModal()
          },
          (error) => {
            setTransferLoading(false)

            Swal.fire({
              title: 'Oops!',
              text: error.response.data.error,
              icon: 'warning',
            })
          },
        )
    }
  }

  const { showAlert } = ShowTGAlert()
  const [debitLoading, setDebitLoading] = useState(false)

  const sendDebitRequest = async () => {
    setDebitLoading(true)
    const msisdn = encodeURIComponent(userData?.msisdn ?? '')
    await loanService.vfdAllowFundDebit(msisdn).then(
      () => {
        toggleDebitModal
        setDebitLoading(false)
        toggleDebitModal()
        showAlert({
          message: 'Debit approved succesfully',
          show: true,
          title: 'Approval Successful',
          type: 'success',
        })
      },
      (error: { response: { data: { error: string } } }) => {
        showAlert({ message: error.response.data.error, show: true, title: 'Error', type: 'error' })
        setDebitLoading(false)
        toggleDebitModal()
      },
    )
  }
  const [updatingWithdrawal, setUpdatingWithdrawal] = useState(false)
  const toggleWithdrawal = async (value: boolean) => {
    setUpdatingWithdrawal(true)
    await customerService.toggleWithdrawal(userData?.msisdn, value ? 'enable' : 'disable').then(
      () => {
        setUpdatingWithdrawal(false)
        showAlert({
          message: `Succesfully ${value ? 'enabled' : 'disabled'} withdrawal`,
          show: true,
          title: 'Done!',
          type: 'success',
        })
      },
      (error: { response: { data: { error: string } } }) => {
        setUpdatingWithdrawal(false)
        showAlert({ message: error.response.data.error, show: true, title: 'Error', type: 'error' })
      },
    )
  }

  const [updatingAccount, setUpdatingAccount] = useState(false)

  const setDefaultAccount = async (account: string) => {
    setUpdatingAccount(true)
    await customerService.defaultAccount(userData?.msisdn, account).then(
      () => {
        setUpdatingAccount(false)
        showAlert({
          message: `Succesfully set ${account} as default account`,
          show: true,
          title: 'Done!',
          type: 'success',
        })

        getUser()
      },
      (error: { response: { data: { error: string } } }) => {
        setUpdatingAccount(false)
        showAlert({ message: error.response.data.error, show: true, title: 'Error', type: 'error' })
      },
    )
  }

  return (
    <div className='UsersDetails'>
      <div className='container'>
        {!user.loanProviderAdminRole && (
          <BreadCrumb
            title={`#${customerAccountId}`}
            parent={'Users'}
            parentUrl={'users'}
            showTitle={false}
          ></BreadCrumb>
        )}

        {userData && (
          <Fragment>
            <div className='row mt-2 mb-4'>
              <div className='col-md-6 d-flex align-items-center gap-3'>
                <div className='account-username'>
                  {userData?.firstName} {userData?.lastName}
                </div>
                <div className='account-plan'>{formatString(userData?.accountPlan)}</div>
                <div className='accont-status'>{userData?.isEnabled ? 'Active' : 'Inactive'}</div>
              </div>

              <div className='col-md-6 d-flex align-items-center gap-3 justify-content-md-end'>
                <button className='btn btn-deactivate'>Deactivate</button>

                <div className='dropdown'>
                  <button
                    className='btn btn-menu'
                    type='button'
                    id={`userMenu-${customerAccountId ?? '0'}`}
                    data-bs-toggle='dropdown'
                    aria-expanded='false'
                  >
                    <svg
                      width='3'
                      height='14'
                      viewBox='0 0 3 14'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M7.89947e-07 6.97001C8.22345e-07 6.22884 0.595589 5.64648 1.32353 5.64648C2.05147 5.64648 2.64706 6.24207 2.64706 6.97001C2.64706 7.69796 2.05147 8.29354 1.32353 8.29354C0.595589 8.29354 7.57549e-07 7.71119 7.89947e-07 6.97001Z'
                        fill='#707070'
                      />
                      <path
                        d='M7.89947e-07 12.6175C8.22345e-07 11.8763 0.595589 11.2939 1.32353 11.2939C2.05147 11.2939 2.64706 11.8895 2.64706 12.6175C2.64706 13.3454 2.05147 13.941 1.32353 13.941C0.595589 13.941 7.57549e-07 13.3587 7.89947e-07 12.6175Z'
                        fill='#707070'
                      />
                      <path
                        d='M7.89947e-07 1.32353C8.22345e-07 0.582353 0.595589 2.60333e-08 1.32353 5.78526e-08C2.05147 8.96719e-08 2.64706 0.595588 2.64706 1.32353C2.64706 2.05147 2.05147 2.64706 1.32353 2.64706C0.595589 2.64706 7.57549e-07 2.06471 7.89947e-07 1.32353Z'
                        fill='#707070'
                      />
                    </svg>
                  </button>

                  <ul className='dropdown-menu shadow-sm border'>
                    {!user.loanProviderAdminRole && (
                      <li>
                        {' '}
                        <Link to={`/user/edit/${userData?.accountId}`} className='dropdown-item'>
                          <span className='d-icon d-pencil'></span> Edit
                        </Link>
                      </li>
                    )}
                    {userData?.loanProvider && (
                      <li>
                        <a
                          className='dropdown-item'
                          href='#'
                          onClick={() => setShowTransferModal(true)}
                        >
                          <span className='d-icon d-arrow-back'></span> Transfer
                        </a>
                      </li>
                    )}
                    <li>
                      <a className='dropdown-item' href='#' onClick={reconcileConsentLink}>
                        <span className='d-icon d-wallet'></span> Reconcile Wallet
                        {reconcileReq === true && (
                          <span className='spinner-border spinner-border-sm'></span>
                        )}
                      </a>
                    </li>
                    {!user.loanProviderAdminRole && (
                      <li>
                        <a className='dropdown-item' href='#' onClick={refreshConsentLink}>
                          <span className='d-icon d-refresh'></span> Refresh Consent Link{' '}
                          {refreshReq === true && (
                            <span className='spinner-border spinner-border-sm'></span>
                          )}
                        </a>
                      </li>
                    )}
                    <li>
                      <a className='dropdown-item' href='#' onClick={toggleDebitModal}>
                        <span className='d-icon d-file-minus'></span> VFD - Allow Debit
                      </a>
                    </li>
                    <li>
                      <a
                        className='dropdown-item'
                        href='#'
                        onClick={() => setShowUpdateTierModal(true)}
                      >
                        <span className='d-icon d-file-minus'></span> Set Tier
                      </a>
                    </li>
                    <li>
                      <a className='dropdown-item' href='#' onClick={() => setTestTierModal(true)}>
                        <span className='d-icon d-file-minus'></span>Test Tier update
                      </a>
                    </li>
                    <li>
                      <a
                        className='dropdown-item'
                        href='#'
                        onClick={() => setSetBoastCycleModal(true)}
                      >
                        <span className='d-icon d-file-minus'></span>Set Boast Cycle
                      </a>
                    </li>
                    <li>
                      <a
                        className='dropdown-item'
                        href='#'
                        onClick={() => setTransferToLoanModal(true)}
                      >
                        <span className='d-icon d-currency-bag-dollar'></span>Transfer to Loan
                        Wallet
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className='row h-100'>
              <div className='col-8 col-md-6 my-auto'>
                <div className='section-title'>Personal Information</div>
              </div>
              <div className='col-4 col-md-6 my-auto text-end'>
                <Link to={`/user/edit/${userData?.accountId}`}>
                  <button className='btn btn-edit border-0'>
                    <svg
                      className='me-2'
                      width='16'
                      height='16'
                      viewBox='0 0 18 18'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M8.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V9.75'
                        stroke='#E873A8'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M12.03 2.26495L6.11997 8.17495C5.89497 8.39995 5.66997 8.84245 5.62497 9.16495L5.30247 11.4224C5.18247 12.2399 5.75997 12.8099 6.57747 12.6974L8.83497 12.3749C9.14997 12.3299 9.59247 12.1049 9.82497 11.8799L15.735 5.96995C16.755 4.94995 17.235 3.76495 15.735 2.26495C14.235 0.764945 13.05 1.24495 12.03 2.26495Z'
                        stroke='#E873A8'
                        strokeWidth='1.5'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                      <path
                        d='M11.1825 3.1123C11.685 4.9048 13.0875 6.3073 14.8875 6.8173'
                        stroke='#E873A8'
                        strokeWidth='1.5'
                        strokeMiterlimit='10'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                    Edit
                  </button>
                </Link>
              </div>
            </div>
            <div className='card border-0- pt-2'>
              <div className='card-body'>
                <div className='row'>
                  <div className='col-xl-3'>
                    <div className='profile-photo shadow-sm mb-3'>
                      <img src={userData?.photo?.url} alt='' className='photo' />
                    </div>
                  </div>
                  <div className='col-xl-9'>
                    <div className='row'>
                      <div className='col-6 col-md-4 mb-3'>
                        <div className='label'>First Name</div>
                        <div className='value'>{userData?.firstName}</div>
                      </div>
                      <div className='col-6  col-md-4 mb-3'>
                        <div className='label'>Last Name</div>
                        <div className='value'>{userData?.lastName}</div>
                      </div>
                      <div className='col-6 col-md-4 mb-3'>
                        <div className='label'>Phone Number</div>
                        <div className='value'>{userData?.msisdn}</div>
                      </div>
                      <div className='col-6 col-md-4 mb-3'>
                        <div className='label'>Email Address</div>
                        <div className='value'>{userData?.emailAddress}</div>
                      </div>
                      <div className='col-6 col-md-4 mb-3'>
                        <div className='label'>Account Plan</div>
                        <div className='value'>{userData?.accountPlan}</div>
                      </div>
                      <div className='col-6 col-md-4 mb-3'>
                        <div className='label'>Country</div>
                        <div className='value'>{userData?.country}</div>
                      </div>
                      <div className='col-6 col-md-4 mb-3'>
                        <div className='label'>Interested In</div>
                        <div className='value'>{userData?.interestedIn}</div>
                      </div>
                      <div className='col-6 col-md-4 mb-3'>
                        <div className='label'>Notification Status</div>
                        <div className='value'>{userData?.notificationsDisabled}</div>
                      </div>
                      <div className='col-6 col-md-4 mb-3'>
                        <div className='label'>Referal Code</div>
                        <div className='value'>{userData?.referralCode}</div>
                      </div>
                      <div className='col-6 col-md-4 mb-3'>
                        <div className='label'>Date Joined</div>
                        <div className='value'>{TimeConverter(userData?.createdAt)}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        )}
        {userData && (
          <Fragment>
            <div className='row'>
              <div className='col-6'>
                <div className='section-title mt-3'>Wallet Information</div>
              </div>
              <div className='col-6'>
                <div className='withdrawal-toggle mt-3'>
                  <div className='form-check form-switch form-check-reverse'>
                    <label className='form-check-label' htmlFor='checkNativeSwitch'>
                      {userData.withdrawalEnabled === true ? 'Disable' : 'Allow'} Withdrawal
                    </label>
                    <input
                      className={
                        userData.withdrawalEnabled === true
                          ? 'form-check-input active'
                          : 'form-check-input'
                      }
                      type='checkbox'
                      id='checkNativeSwitch'
                      checked={userData.withdrawalEnabled === true ? true : false}
                      onChange={(e) => toggleWithdrawal(e.target.checked)}
                    />
                    {updatingWithdrawal && (
                      <span className='spinner-border spinner-border-sm'></span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <div className='card'>
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-2 col-xl-1'>
                        <svg
                          width='48'
                          height='48'
                          viewBox='0 0 48 48'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <rect width='48' height='48' rx='24' fill='#F2F2F2' />
                          <path
                            d='M30.04 25.55C29.62 25.96 29.38 26.55 29.44 27.18C29.53 28.26 30.52 29.05 31.6 29.05H33.5V30.24C33.5 32.31 31.81 34 29.74 34H18.26C16.19 34 14.5 32.31 14.5 30.24V23.51C14.5 21.44 16.19 19.75 18.26 19.75H29.74C31.81 19.75 33.5 21.44 33.5 23.51V24.95H31.48C30.92 24.95 30.41 25.17 30.04 25.55Z'
                            stroke='#292D32'
                            strokeWidth='1.5'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                          <path
                            d='M14.5 24.4103V19.8403C14.5 18.6503 15.23 17.5903 16.34 17.1703L24.28 14.1703C25.52 13.7003 26.85 14.6203 26.85 15.9503V19.7503'
                            stroke='#292D32'
                            strokeWidth='1.5'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                          <path
                            d='M34.5588 25.9702V28.0302C34.5588 28.5802 34.1188 29.0302 33.5588 29.0502H31.5988C30.5188 29.0502 29.5288 28.2602 29.4388 27.1802C29.3788 26.5502 29.6188 25.9602 30.0388 25.5502C30.4088 25.1702 30.9188 24.9502 31.4788 24.9502H33.5588C34.1188 24.9702 34.5588 25.4202 34.5588 25.9702Z'
                            stroke='#292D32'
                            strokeWidth='1.5'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                          <path
                            d='M19 24H26'
                            stroke='#292D32'
                            strokeWidth='1.5'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                        </svg>
                      </div>
                      <div className='col-10 col-xl-9'>
                        <div className='wallet-label'>Wallet Balance</div>
                        <div className='wallet-value'>
                          {userData?.walletBalance?.currency}
                          {CurrencyFormatter(Number(userData?.walletBalance?.amountMajor))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md-6'>
                <div className='card'>
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-2 col-xl-1'>
                        <svg
                          width='48'
                          height='48'
                          viewBox='0 0 48 48'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <rect width='48' height='48' rx='24' fill='#F2F2F2' />
                          <path
                            d='M14 20.5049H34'
                            stroke='#292D32'
                            strokeWidth='1.5'
                            strokeMiterlimit='10'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                          <path
                            d='M18 28.5049H20'
                            stroke='#292D32'
                            strokeWidth='1.5'
                            strokeMiterlimit='10'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                          <path
                            d='M22.5 28.5049H26.5'
                            stroke='#292D32'
                            strokeWidth='1.5'
                            strokeMiterlimit='10'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                          <path
                            d='M18.44 15.5049H29.55C33.11 15.5049 34 16.3849 34 19.8949V28.1049C34 31.6149 33.11 32.4949 29.56 32.4949H18.44C14.89 32.5049 14 31.6249 14 28.1149V19.8949C14 16.3849 14.89 15.5049 18.44 15.5049Z'
                            stroke='#292D32'
                            strokeWidth='1.5'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                          />
                        </svg>
                      </div>
                      <div className='col-10 col-xl-9'>
                        <div className='wallet-label'>Traderscard Ballance</div>
                        <div className='wallet-value'>
                          {userData?.loanBalance?.currency}
                          {CurrencyFormatter(Number(userData?.loanBalance?.amountMajor))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        )}

        <div className='row mt-3'>
          <div className='col-xl-8'>
            <div style={{ height: '30px' }} className='mb-3'>
              <div className='row  h-100'>
                <div className='col-md-6 my-auto'>
                  <div className='section-title'>Referrals</div>
                </div>
                <div className='col-md-6 my-auto text-end'>
                  <Link to={''}>
                    <button className='btn btn-edit border-0'>See All</button>
                  </Link>
                </div>
              </div>
            </div>

            <div className='card mt-0'>
              <div className='card-body'>
                <div className='table-responsive'>
                  <table className='table'>
                    <thead>
                      <tr>
                        <th>Customer</th>
                        <th>Package</th>
                        {/* <th>Earning</th>
                        <th>Status</th> */}
                        <th>Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {customerReferrals &&
                        customerReferrals.map((referal: CustomerType, index: Key) => (
                          <tr key={index}>
                            <td>
                              {referal.firstName} {referal.lastName}
                            </td>
                            <td>{referal.accountPlan}</td>
                            {/* <td>₦100,000.00</td>
                            <td>
                              <span className='pending'>Pending</span>
                            </td> */}
                            <td>{TimeConverter(referal.createdAt)}</td>
                            <td>
                              <Link to={`/user-new/${referal.accountId}`}>
                                <button className='btn'>View</button>
                              </Link>
                            </td>
                          </tr>
                        ))}

                      {/* <tr>
                        <td>Fola Adeyemi</td>
                        <td>Tradegrid Plus Lite</td>
                        <td>₦100,000.00</td>
                        <td>
                          <span className='converted'>Converted</span>
                        </td>
                        <td>24/09/2022</td>
                        <td>
                          <button className='btn'>View</button>
                        </td>
                      </tr> */}

                      {loading === false && customerReferrals?.length === 0 && (
                        <tr>
                          <td colSpan={7} className='text-center'>
                            No referal found
                          </td>
                        </tr>
                      )}
                      {loading === true && !customerReferrals && (
                        <tr>
                          <td colSpan={7} className='text-center'>
                            <HorizontalLoader></HorizontalLoader>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div className='col-md-6 col-xl-4'>
            <div className='section-title mb-3 mt-1'>Bank Account Details</div>
            <div className='card'>
              {accountRequest === true && (
                <div
                  style={{ height: '200px' }}
                  className='card-body w-100 d-flex justify-content-center align-items-center'
                >
                  <span className='spinner-border spinner-border-sm'></span>
                </div>
              )}
              {accountRequest === false && (
                <Fragment>
                  <div className='card-body pb-0'>
                    <ul className='nav nav-tabs custom-tabs' role='tablist'>
                      <li className='nav-item' role='presentation'>
                        <button
                          className='nav-link active'
                          id='paystack-tab'
                          data-bs-toggle='tab'
                          data-bs-target='#paystack'
                          type='button'
                          role='tab'
                        >
                          Paystack
                        </button>
                      </li>

                      <li className='nav-item' role='presentation'>
                        <button
                          className='nav-link'
                          id='nomba-tab'
                          data-bs-toggle='tab'
                          data-bs-target='#nomba'
                          type='button'
                          role='tab'
                        >
                          Nomba
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div className='card-body'>
                    <div className='tab-content'>
                      <div className='tab-pane fade show active' id='paystack' role='tabpanel'>
                        {paystackAccountError && (
                          <div
                            style={{ height: '200px', fontSize: '.89rem' }}
                            className='card-body w-100 d-flex justify-content-center align-items-center text-center'
                          >
                            {paystackAccountError}
                          </div>
                        )}
                        {!paystackAccountError && (
                          <Fragment>
                            <div className='bank-item d-flex align-items-center gap-3'>
                              <svg
                                width='39'
                                height='39'
                                viewBox='0 0 48 48'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <circle cx='24' cy='24' r='24' fill='#0E1F33' fillOpacity='0.1' />
                                <path
                                  d='M34.3783 28.8656V31.7845H14.9188V28.8656C14.9188 28.3304 15.3567 27.8926 15.8918 27.8926H33.4053C33.9404 27.8926 34.3783 28.3304 34.3783 28.8656Z'
                                  fill='#0E1F33'
                                  stroke='#0E1F33'
                                  strokeWidth='1.5'
                                  strokeMiterlimit='10'
                                  strokeLinecap='round'
                                  strokeLinejoin='round'
                                />
                                <path
                                  d='M19.7837 21.082H17.8378V27.8928H19.7837V21.082Z'
                                  fill='#0E1F33'
                                />
                                <path
                                  d='M23.6756 21.082H21.7297V27.8928H23.6756V21.082Z'
                                  fill='#0E1F33'
                                />
                                <path
                                  d='M27.5675 21.082H25.6215V27.8928H27.5675V21.082Z'
                                  fill='#0E1F33'
                                />
                                <path
                                  d='M31.4594 21.082H29.5134V27.8928H31.4594V21.082Z'
                                  fill='#0E1F33'
                                />
                                <path
                                  d='M35.3513 32.5141H13.9459C13.5469 32.5141 13.2161 32.1833 13.2161 31.7844C13.2161 31.3855 13.5469 31.0547 13.9459 31.0547H35.3513C35.7502 31.0547 36.081 31.3855 36.081 31.7844C36.081 32.1833 35.7502 32.5141 35.3513 32.5141Z'
                                  fill='#0E1F33'
                                />
                                <path
                                  d='M33.7653 15.9732L25.0086 12.4705C24.814 12.3926 24.4831 12.3926 24.2886 12.4705L15.5318 15.9732C15.1913 16.1094 14.9188 16.5083 14.9188 16.8781V20.1083C14.9188 20.6435 15.3567 21.0813 15.8918 21.0813H33.4053C33.9404 21.0813 34.3783 20.6435 34.3783 20.1083V16.8781C34.3783 16.5083 34.1059 16.1094 33.7653 15.9732ZM24.6486 18.6489C23.841 18.6489 23.1891 17.997 23.1891 17.1894C23.1891 16.3818 23.841 15.7299 24.6486 15.7299C25.4561 15.7299 26.108 16.3818 26.108 17.1894C26.108 17.997 25.4561 18.6489 24.6486 18.6489Z'
                                  fill='#0E1F33'
                                />
                              </svg>
                              <div className='col-6 col-md-4 mb-3'>
                                <div className='label'>Bank</div>
                                <div className='value'>{paystactAccount?.bankName}</div>
                              </div>
                            </div>

                            <div className='bank-item d-flex align-items-center gap-3'>
                              <svg
                                width='39'
                                height='39'
                                viewBox='0 0 48 48'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <rect
                                  width='48'
                                  height='48'
                                  rx='24'
                                  fill='#0E1F33'
                                  fillOpacity='0.1'
                                />
                                <path
                                  d='M27.8002 22.9892L27.4054 24.9365H29.0975V27.2257H26.9401L26.4747 29.5H24.2186L24.6839 27.2257H22.3431L21.8778 29.5H19.6216L20.087 27.2257H18V24.9365H20.5523L20.9471 22.9892H18.9025V20.7H21.3984L21.8496 18.5H24.1058L23.6545 20.7H25.9953L26.4465 18.5H28.7027L28.2515 20.7H30V22.9892H27.8002ZM25.5441 22.9892H23.2033L22.8085 24.9365H25.1492L25.5441 22.9892Z'
                                  fill='black'
                                />
                              </svg>

                              <div className='col-6 col-md-4 mb-3'>
                                <div className='label'>Account Number</div>
                                <div className='value'>{paystactAccount?.bankAccountNumber}</div>
                              </div>
                            </div>

                            <div className='bank-item d-flex align-items-center gap-3'>
                              <svg
                                width='39'
                                height='39'
                                viewBox='0 0 48 48'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <circle cx='24' cy='24' r='24' fill='#0E1F33' fillOpacity='0.1' />
                                <path
                                  d='M24.6486 24.6487C27.3353 24.6487 29.5134 22.4706 29.5134 19.7838C29.5134 17.097 27.3353 14.9189 24.6486 14.9189C21.9618 14.9189 19.7837 17.097 19.7837 19.7838C19.7837 22.4706 21.9618 24.6487 24.6486 24.6487Z'
                                  fill='#292D32'
                                />
                                <path
                                  d='M24.6486 27.0811C19.774 27.0811 15.8043 30.3502 15.8043 34.3784C15.8043 34.6508 16.0183 34.8648 16.2907 34.8648H33.0064C33.2789 34.8648 33.4929 34.6508 33.4929 34.3784C33.4929 30.3502 29.5232 27.0811 24.6486 27.0811Z'
                                  fill='#292D32'
                                />
                              </svg>

                              <div className='col-6 col-md-4 mb-3'>
                                <div className='label'>Name</div>
                                <div className='value'>{paystactAccount?.bankAccountName}</div>
                              </div>
                            </div>

                            <div className='set-default-bank'>
                              <input
                                type='checkbox'
                                checked={
                                  userData?.dedicatedAccountProvider === 'PAYSTACK' ? true : false
                                }
                                onChange={() => setDefaultAccount('PAYSTACK')}
                              />
                              <label htmlFor=''>Set as the Dedicated Account Provider</label>
                            </div>
                          </Fragment>
                        )}
                      </div>

                      <div className='tab-pane fade' id='nomba' role='tabpanel'>
                        {' '}
                        {nomaAccountError && (
                          <div
                            style={{ height: '200px', fontSize: '.89rem' }}
                            className='card-body w-100 d-flex justify-content-center align-items-center text-center'
                          >
                            {nomaAccountError}
                          </div>
                        )}
                        {!nomaAccountError && (
                          <Fragment>
                            <div className='bank-item d-flex align-items-center gap-3'>
                              <svg
                                width='39'
                                height='39'
                                viewBox='0 0 48 48'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <circle cx='24' cy='24' r='24' fill='#0E1F33' fillOpacity='0.1' />
                                <path
                                  d='M34.3783 28.8656V31.7845H14.9188V28.8656C14.9188 28.3304 15.3567 27.8926 15.8918 27.8926H33.4053C33.9404 27.8926 34.3783 28.3304 34.3783 28.8656Z'
                                  fill='#0E1F33'
                                  stroke='#0E1F33'
                                  strokeWidth='1.5'
                                  strokeMiterlimit='10'
                                  strokeLinecap='round'
                                  strokeLinejoin='round'
                                />
                                <path
                                  d='M19.7837 21.082H17.8378V27.8928H19.7837V21.082Z'
                                  fill='#0E1F33'
                                />
                                <path
                                  d='M23.6756 21.082H21.7297V27.8928H23.6756V21.082Z'
                                  fill='#0E1F33'
                                />
                                <path
                                  d='M27.5675 21.082H25.6215V27.8928H27.5675V21.082Z'
                                  fill='#0E1F33'
                                />
                                <path
                                  d='M31.4594 21.082H29.5134V27.8928H31.4594V21.082Z'
                                  fill='#0E1F33'
                                />
                                <path
                                  d='M35.3513 32.5141H13.9459C13.5469 32.5141 13.2161 32.1833 13.2161 31.7844C13.2161 31.3855 13.5469 31.0547 13.9459 31.0547H35.3513C35.7502 31.0547 36.081 31.3855 36.081 31.7844C36.081 32.1833 35.7502 32.5141 35.3513 32.5141Z'
                                  fill='#0E1F33'
                                />
                                <path
                                  d='M33.7653 15.9732L25.0086 12.4705C24.814 12.3926 24.4831 12.3926 24.2886 12.4705L15.5318 15.9732C15.1913 16.1094 14.9188 16.5083 14.9188 16.8781V20.1083C14.9188 20.6435 15.3567 21.0813 15.8918 21.0813H33.4053C33.9404 21.0813 34.3783 20.6435 34.3783 20.1083V16.8781C34.3783 16.5083 34.1059 16.1094 33.7653 15.9732ZM24.6486 18.6489C23.841 18.6489 23.1891 17.997 23.1891 17.1894C23.1891 16.3818 23.841 15.7299 24.6486 15.7299C25.4561 15.7299 26.108 16.3818 26.108 17.1894C26.108 17.997 25.4561 18.6489 24.6486 18.6489Z'
                                  fill='#0E1F33'
                                />
                              </svg>
                              <div className='col-6 col-md-4 mb-3'>
                                <div className='label'>Bank</div>
                                <div className='value'>{nomaAccount?.bankName}</div>
                              </div>
                            </div>
                            <div className='bank-item d-flex align-items-center gap-3'>
                              <svg
                                width='39'
                                height='39'
                                viewBox='0 0 48 48'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <rect
                                  width='48'
                                  height='48'
                                  rx='24'
                                  fill='#0E1F33'
                                  fillOpacity='0.1'
                                />
                                <path
                                  d='M27.8002 22.9892L27.4054 24.9365H29.0975V27.2257H26.9401L26.4747 29.5H24.2186L24.6839 27.2257H22.3431L21.8778 29.5H19.6216L20.087 27.2257H18V24.9365H20.5523L20.9471 22.9892H18.9025V20.7H21.3984L21.8496 18.5H24.1058L23.6545 20.7H25.9953L26.4465 18.5H28.7027L28.2515 20.7H30V22.9892H27.8002ZM25.5441 22.9892H23.2033L22.8085 24.9365H25.1492L25.5441 22.9892Z'
                                  fill='black'
                                />
                              </svg>

                              <div className='col-6 col-md-4 mb-3'>
                                <div className='label'>Account Number</div>
                                <div className='value'>{nomaAccount?.bankAccountNumber}</div>
                              </div>
                            </div>
                            <div className='bank-item d-flex align-items-center gap-3'>
                              <svg
                                width='39'
                                height='39'
                                viewBox='0 0 48 48'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <circle cx='24' cy='24' r='24' fill='#0E1F33' fillOpacity='0.1' />
                                <path
                                  d='M24.6486 24.6487C27.3353 24.6487 29.5134 22.4706 29.5134 19.7838C29.5134 17.097 27.3353 14.9189 24.6486 14.9189C21.9618 14.9189 19.7837 17.097 19.7837 19.7838C19.7837 22.4706 21.9618 24.6487 24.6486 24.6487Z'
                                  fill='#292D32'
                                />
                                <path
                                  d='M24.6486 27.0811C19.774 27.0811 15.8043 30.3502 15.8043 34.3784C15.8043 34.6508 16.0183 34.8648 16.2907 34.8648H33.0064C33.2789 34.8648 33.4929 34.6508 33.4929 34.3784C33.4929 30.3502 29.5232 27.0811 24.6486 27.0811Z'
                                  fill='#292D32'
                                />
                              </svg>

                              <div className='col-6 col-md-4 mb-3'>
                                <div className='label'>Name</div>
                                <div className='value'>{nomaAccount?.bankAccountName}</div>
                              </div>
                            </div>
                            <div className='set-default-bank'>
                              <input
                                type='checkbox'
                                checked={
                                  userData?.dedicatedAccountProvider === 'NOMBA' ? true : false
                                }
                                onChange={() => setDefaultAccount('NOMBA')}
                              />
                              <label htmlFor=''>Set as the Dedicated Account Provider</label>
                            </div>
                          </Fragment>
                        )}
                      </div>
                    </div>
                  </div>
                </Fragment>
              )}
            </div>

            <div className='section-title mt-4'>Tier Progress</div>
            <div className='card tier-card'>
              <div className='card-body p-2 px-3'>
                <div className='select-option border-bottom p-2 d-flex justify-content-between align-items-center'>
                  <div className='type-label'>Product Type</div>
                  <div className='d-flex align-items-center'>
                    <select
                      className='form-select form-select-sm me-2'
                      onChange={(e) => setProductType(e.target.value)}
                    >
                      <option value='AGO'>AGO (Diesel)</option>
                      <option value='PMS'>PMS (Petrol)</option>
                      <option value='LPG'>LPG</option>
                    </select>
                  </div>
                </div>

                <div className='stars text-center py-5 d-flex justify-content-center align-items-center gap-3'>
                  <svg
                    width='30'
                    height='30'
                    viewBox='0 0 36 34'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M14.696 2.07314C15.594 -0.690793 19.5042 -0.690787 20.4023 2.07314L22.4884 8.49362C22.8901 9.72969 24.0419 10.5666 25.3416 10.5666H32.0925C34.9987 10.5666 36.207 14.2854 33.8559 15.9936L28.3943 19.9617C27.3428 20.7256 26.9028 22.0797 27.3045 23.3158L29.3906 29.7363C30.2887 32.5002 27.1252 34.7986 24.7741 33.0904L19.3125 29.1223C18.261 28.3584 16.8372 28.3584 15.7858 29.1223L10.3242 33.0904C7.97305 34.7986 4.80962 32.5002 5.70767 29.7363L7.79381 23.3158C8.19543 22.0797 7.75546 20.7256 6.704 19.9617L1.24241 15.9936C-1.10873 14.2854 0.0996003 10.5666 3.00577 10.5666H9.75666C11.0563 10.5666 12.2082 9.72968 12.6098 8.49362L14.696 2.07314Z'
                      fill='#FFC300'
                    />
                  </svg>
                  <svg
                    width='30'
                    height='30'
                    viewBox='0 0 36 34'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M14.696 2.07314C15.594 -0.690793 19.5042 -0.690787 20.4023 2.07314L22.4884 8.49362C22.8901 9.72969 24.0419 10.5666 25.3416 10.5666H32.0925C34.9987 10.5666 36.207 14.2854 33.8559 15.9936L28.3943 19.9617C27.3428 20.7256 26.9028 22.0797 27.3045 23.3158L29.3906 29.7363C30.2887 32.5002 27.1252 34.7986 24.7741 33.0904L19.3125 29.1223C18.261 28.3584 16.8372 28.3584 15.7858 29.1223L10.3242 33.0904C7.97305 34.7986 4.80962 32.5002 5.70767 29.7363L7.79381 23.3158C8.19543 22.0797 7.75546 20.7256 6.704 19.9617L1.24241 15.9936C-1.10873 14.2854 0.0996003 10.5666 3.00577 10.5666H9.75666C11.0563 10.5666 12.2082 9.72968 12.6098 8.49362L14.696 2.07314Z'
                      fill='#FFC300'
                    />
                  </svg>
                  <svg
                    width='30'
                    height='30'
                    viewBox='0 0 36 34'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M14.696 2.07314C15.594 -0.690793 19.5042 -0.690787 20.4023 2.07314L22.4884 8.49362C22.8901 9.72969 24.0419 10.5666 25.3416 10.5666H32.0925C34.9987 10.5666 36.207 14.2854 33.8559 15.9936L28.3943 19.9617C27.3428 20.7256 26.9028 22.0797 27.3045 23.3158L29.3906 29.7363C30.2887 32.5002 27.1252 34.7986 24.7741 33.0904L19.3125 29.1223C18.261 28.3584 16.8372 28.3584 15.7858 29.1223L10.3242 33.0904C7.97305 34.7986 4.80962 32.5002 5.70767 29.7363L7.79381 23.3158C8.19543 22.0797 7.75546 20.7256 6.704 19.9617L1.24241 15.9936C-1.10873 14.2854 0.0996003 10.5666 3.00577 10.5666H9.75666C11.0563 10.5666 12.2082 9.72968 12.6098 8.49362L14.696 2.07314Z'
                      fill='#D9D9D9'
                    />
                  </svg>
                  <svg
                    width='30'
                    height='30'
                    viewBox='0 0 36 34'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M14.696 2.07314C15.594 -0.690793 19.5042 -0.690787 20.4023 2.07314L22.4884 8.49362C22.8901 9.72969 24.0419 10.5666 25.3416 10.5666H32.0925C34.9987 10.5666 36.207 14.2854 33.8559 15.9936L28.3943 19.9617C27.3428 20.7256 26.9028 22.0797 27.3045 23.3158L29.3906 29.7363C30.2887 32.5002 27.1252 34.7986 24.7741 33.0904L19.3125 29.1223C18.261 28.3584 16.8372 28.3584 15.7858 29.1223L10.3242 33.0904C7.97305 34.7986 4.80962 32.5002 5.70767 29.7363L7.79381 23.3158C8.19543 22.0797 7.75546 20.7256 6.704 19.9617L1.24241 15.9936C-1.10873 14.2854 0.0996003 10.5666 3.00577 10.5666H9.75666C11.0563 10.5666 12.2082 9.72968 12.6098 8.49362L14.696 2.07314Z'
                      fill='#D9D9D9'
                    />
                  </svg>
                  <svg
                    width='30'
                    height='30'
                    viewBox='0 0 36 34'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M14.696 2.07314C15.594 -0.690793 19.5042 -0.690787 20.4023 2.07314L22.4884 8.49362C22.8901 9.72969 24.0419 10.5666 25.3416 10.5666H32.0925C34.9987 10.5666 36.207 14.2854 33.8559 15.9936L28.3943 19.9617C27.3428 20.7256 26.9028 22.0797 27.3045 23.3158L29.3906 29.7363C30.2887 32.5002 27.1252 34.7986 24.7741 33.0904L19.3125 29.1223C18.261 28.3584 16.8372 28.3584 15.7858 29.1223L10.3242 33.0904C7.97305 34.7986 4.80962 32.5002 5.70767 29.7363L7.79381 23.3158C8.19543 22.0797 7.75546 20.7256 6.704 19.9617L1.24241 15.9936C-1.10873 14.2854 0.0996003 10.5666 3.00577 10.5666H9.75666C11.0563 10.5666 12.2082 9.72968 12.6098 8.49362L14.696 2.07314Z'
                      fill='#D9D9D9'
                    />
                  </svg>
                </div>

                <div className='row'>
                  <div className='col-6 label'>Volume to Next Tier</div>
                  <div className='col-6 value text-end'>
                    {tierInfo?.currentTier.threshold} litres
                  </div>
                </div>

                <div className='row mt-3 h-100 mb-4'>
                  <div className='col-9 label my-auto'>
                    <div className='progress' style={{ height: '10px' }}>
                      <div
                        className='progress-bar'
                        role='progressbar'
                        style={{
                          width: tierInfo?.progressToNextTier,
                          backgroundColor: '#2AAB61',
                        }}
                        aria-valuenow={65}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      />
                    </div>
                  </div>
                  <div className='col-3 value text-end my-auto'>
                    <svg
                      className='mb-1'
                      width='20'
                      height='20'
                      viewBox='0 0 27 27'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M19.7498 11.5676H19.0632L19.0643 8.02384C19.0643 4.84773 16.5552 2.24805 13.4897 2.24805C10.4242 2.24805 7.91509 4.84773 7.91509 8.02384V11.5676H7.22848C6.13816 11.5676 5.24597 12.492 5.24597 13.6216V22.6767C5.24597 23.8063 6.13816 24.7307 7.22848 24.7307H19.7497C20.84 24.7307 21.7322 23.8063 21.7322 22.6767L21.7333 13.6216C21.7333 12.492 20.8412 11.5676 19.7498 11.5676ZM10.3915 8.02384C10.3915 6.25853 11.7859 4.81372 13.4898 4.81372C15.1936 4.81372 16.5881 6.25847 16.5881 8.02384V11.5676H10.3915V8.02384ZM14.3247 18.001V20.6567C14.3247 21.132 13.9507 21.5218 13.4897 21.5218C13.0309 21.5218 12.6548 21.1342 12.6548 20.6567V18.001C12.1557 17.7035 11.8219 17.1436 11.8219 16.5057C11.8219 15.5506 12.5679 14.7778 13.4897 14.7778C14.4116 14.7778 15.1575 15.5506 15.1575 16.5057C15.1575 17.1436 14.8216 17.7024 14.3247 18.001Z'
                        fill='#FFC300'
                      />
                    </svg>{' '}
                    {tierInfo?.currentTier.tier}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalWrapper showModal={showDebitModal} closeModal={toggleDebitModal} title='Confirmation!'>
        <small>
          Are you sure you want to authorize TradeGrid to debit the customer&lsquo;s VFD bank
          account?
        </small>
        <div className='mt-4'>
          <button className='btn btn-default' onClick={sendDebitRequest} disabled={debitLoading}>
            Continue {debitLoading && <span className='spinner-border spinner-border-sm'></span>}
          </button>
        </div>
      </ModalWrapper>

      <ModalWrapper
        showModal={showTransferModal}
        closeModal={toggleTransferModal}
        title='Wallet Transfer'
      >
        <small>
          This action is not reversible. Are you sure you want to continue? if yes, kindly input the
          amount in the field below.
        </small>

        <form onSubmit={handleSubmit((data: { amount: number }) => submitTransfer(data))}>
          <div className='form-input mt-4'>
            <label htmlFor='amount' className='amount-label'>
              Amount
            </label>
            <input type='number' id='amount' className='form-control' {...register('amount')} />
            {errors.amount && <span className='errors'>{errors.amount.message}</span>}
          </div>

          <div className='mt-3'>
            <button className='btn btn-default'>
              Submit {transferLoading && <span className='spinner-border spinner-border-sm'></span>}
            </button>
          </div>
        </form>
      </ModalWrapper>

      <ModalWrapper
        showModal={showUpdateTierModal}
        closeModal={() => setShowUpdateTierModal(false)}
        title='Set Tier'
        hideHeader={false}
      >
        <CashBackTierModal
          setShowUpdateTierModal={() => setShowUpdateTierModal(false)}
          msisdn={userData?.msisdn}
        ></CashBackTierModal>
      </ModalWrapper>

      <ModalWrapper
        showModal={showTestTierModal}
        closeModal={() => setTestTierModal(false)}
        title='Test Tier Update'
        hideHeader={false}
      >
        <TestTierUpdateModal
          setTestTierModal={() => setTestTierModal(false)}
          msisdn={userData?.msisdn}
        ></TestTierUpdateModal>
      </ModalWrapper>

      <ModalWrapper
        showModal={showSetBoastCycleModal}
        closeModal={() => setSetBoastCycleModal(false)}
        title='Set Boost Cycle Start Date'
        hideHeader={false}
      >
        <SetBoostCycleModal
          setTestTierModal={() => setSetBoastCycleModal(false)}
          msisdn={userData?.msisdn}
        ></SetBoostCycleModal>
      </ModalWrapper>

      <ModalWrapper
        showModal={transferToLoanModal}
        closeModal={() => setTransferToLoanModal(false)}
        title='Transfer Funds to TradersCard Wallet'
        hideHeader={false}
      >
        <TransferToLoan msisdn={userData?.msisdn}></TransferToLoan>
      </ModalWrapper>
    </div>
  )
}

export default UserDetails
